/* eslint-disable @typescript-eslint/no-explicit-any */

import noUiSlider, { type target } from "nouislider";
import { useEffect } from "react";
import { useAuth } from "../../../../app/modules/auth";
import { AuthUserHeader } from "../../../partials/layout/theme-mode/AuthUserHeader";
import { useLayout } from "../../core";
import { DefaultTitle } from "./page-title/DefaultTitle";

const HeaderToolbar = () => {
	const { classes } = useLayout();
	const { currentUser } = useAuth();
	const _roleID = [1, 6, 8, 9];
	// useEffect(() => {
	//   const slider: target = document.querySelector('#kt_toolbar_slider') as target
	//   const rangeSliderValueElement: Element | null = document.querySelector(
	//     '#kt_toolbar_slider_value'
	//   )

	//   if (!slider) {
	//     return
	//   }

	//   slider.innerHTML = ''

	//   noUiSlider.create(slider, {
	//     start: [5],
	//     connect: [true, false],
	//     step: 1,
	//     range: {
	//       min: [1],
	//       max: [10],
	//     },
	//   })

	//   slider.noUiSlider?.on('update', function (values: any, handle: any) {
	//     if (!rangeSliderValueElement) {
	//       return
	//     }

	//     rangeSliderValueElement.innerHTML = parseInt(values[handle]).toFixed(1)
	//   })
	// }, [])

	useEffect(() => {
		const slider = document.querySelector(
			"#kt_toolbar_slider",
		) as target | null;
		const rangeSliderValueElement = document.querySelector(
			"#kt_toolbar_slider_value",
		);

		if (!slider || (slider as any).noUiSlider) {
			return;
		}

		noUiSlider.create(slider, {
			start: [5],
			connect: [true, false],
			step: 1,
			range: {
				min: [1],
				max: [10],
			},
		});

		(slider as any).noUiSlider?.on("update", (values: any, handle: any) => {
			if (!rangeSliderValueElement) return;
			rangeSliderValueElement.innerHTML = parseInt(values[handle], 10).toFixed(
				1,
			);
		});

		// Cleanup if necessary
		return () => {
			if (slider && (slider as any).noUiSlider) {
				(slider as any).noUiSlider.destroy();
			}
		};
	}, []);

	return (
		<div className="toolbar d-flex align-items-stretch flex-grow-1">
			{/* begin::Toolbar container */}
			<div
				className={`${classes.headerContainer.join(
					" ",
				)} d-flex flex-row align-items-center justify-content-between w-100 h-100`}
			>
				<DefaultTitle />
				<div className="d-flex overflow-visible align-items-center">
					{/* begin::Action wrapper */}
					<div className="d-flex align-items-center overflow-visible">
						{/* begin::Actions */}
						<AuthUserHeader toggleBtnClass="" />
						{/* end::Actions */}
					</div>
				</div>
				{/* end::Toolbar container */}
			</div>
		</div>
	);
};

export { HeaderToolbar };
